import * as React from 'react';
import { cn } from '@/lib/utils';

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'flex min-h-[80px] w-full rounded-md border border-[var(--border)] bg-[var(--input)] px-3 py-2 ' +
        'text-sm placeholder:text-[var(--muted-foreground)] focus-visible:outline-none focus-visible:ring-2 ' +
        'focus-visible:ring-[var(--ring)] disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';
